import { Component } from '../lib/ComponentBase';
import { simpleComponent } from '../lib/ComponentHelpers';
import type { DataComponent } from '../types/Components';

/**
 * A component that stores the predicted state of an actor at a future time.
 * This is typically calculated relative to the player's next turn.
 */
class PredictedState extends Component implements DataComponent {
  totalPredictedEnergy: number;

  constructor(data: { totalPredictedEnergy?: number } = {}) {
    super();
    this.totalPredictedEnergy = data.totalPredictedEnergy ?? 0;
  }
}

export default simpleComponent(PredictedState);
